"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = arePropsEqual;
var _shallowEqual = require("shallow-equal");
function arePropsEqual(prev, current) {
  const {
    bemit: prev_bemit,
    ...prev_props
  } = prev;
  const {
    bemit,
    ...props
  } = current;
  if ((0, _shallowEqual.shallowEqualArrays)(prev_bemit, bemit) === false) return false;
  return (0, _shallowEqual.shallowEqualObjects)(props, prev_props);
}
